const locale = {
  placeholder: 'اختيار الوقت',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ar_EG.tsx